import styled from 'styled-components';
import type { TypographyProps } from '@elfsight/widget-ui';
import { Typography } from '@elfsight/widget-ui';
import { createReadableClass } from '@elfsight/widget-utils';
import { ellipsis } from '../../../helpers';
import type { ExtendedAudioItem } from '../../sources';

interface TitleProps {
  textStyle: TypographyProps['textStyle'];
  wrap?: boolean;
  track?: ExtendedAudioItem;
}

export function Title({ textStyle, wrap, track }: TitleProps) {
  const { title, hasTitle } = track ?? {};

  if (!hasTitle) {
    return null;
  }

  return (
    <StyledTitle textStyle={textStyle} _wrap={wrap}>
      {title}
    </StyledTitle>
  );
}

export const StyledTitle = styled(Typography).attrs<{
  _wrap?: boolean;
}>({
  className: createReadableClass({
    component: 'track-info',
    element: 'title'
  })
})`
  max-width: 100%;

  ${({ _wrap }) => !_wrap && ellipsis}
`;
